import { render, staticRenderFns } from "./BeauticianForm.vue?vue&type=template&id=3a74350c&scoped=true"
import script from "./BeauticianForm.vue?vue&type=script&lang=js"
export * from "./BeauticianForm.vue?vue&type=script&lang=js"
import style0 from "./BeauticianForm.vue?vue&type=style&index=0&id=3a74350c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a74350c",
  null
  
)

export default component.exports